module.exports = window["MaterialUI"].Divider;